module.exports = __webpack_public_path__ + "img/csm_Ersa-ECOSELECT4-01-900x675_c2dae979aa.a8132892.png";